var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { environment } from '../../../../environments/environment';
import { AccessLevel } from '../../../common/enums/access-level.enum';
import { Permission } from '../../../common/enums/permission.enum';
import { CacheKey } from '../../../shared/constants/cachekey.constants';
import { CacheService } from '../../../shared/services/cache.service';
import { CommonService } from '../../../shared/services/common.service';
import { Utils } from '../../../shared/Utils/utils';
import { DateConstants } from '../../constants/date.constants';
import { SubCategoryConstants } from '../../constants/reports.constants';
import { OperatingCountryEnums } from '../../enums/countries.enums';
import { ReportCategoryEnum } from '../../enums/report-category.enum';
import { Period } from '../../enums/period.enum';
import { ReportTab } from '../../enums/report-tab.enum';
import { CustomerService } from '../../services/customer.service';
import { OrderService } from '../../services/order.service';
import { MemberStatus } from '../../enums/member-status.enum';
var ReportsComponent = /** @class */ (function () {
    function ReportsComponent(_customerService, _cacheService, _formbuilder, _orderService, _commonService) {
        this._customerService = _customerService;
        this._cacheService = _cacheService;
        this._formbuilder = _formbuilder;
        this._orderService = _orderService;
        this._commonService = _commonService;
        this.operatingCountries = [];
        this.countries = [];
        this.stores = [];
        this.businessEntities = [];
        this.reportsForm = null;
        this.reportsCategoryEnum = ReportCategoryEnum;
        this.activeTab = ReportTab.INVOICE_PRINTING;
        this.reportCategories = [];
        this.posLocations = [];
        this.subReports = [];
        this.subCategoryConstants = SubCategoryConstants;
        this.currentDate = new Date();
        this.isSubmitted = false;
        this.isLoading = false;
        this.areaCode = '';
        this.dataLoadedCount = 0;
        this.momentConstructor = moment.default || moment;
        this.dateRangeDuration = environment.reportDownloadDurationMonths;
        this.posPaymentMethods = [];
        this.reportTab = ReportTab;
        this.hasManageReportPermission = false;
        this.hasInvoicePrintingPermission = false;
        this.hasRunReportPermission = false;
        this.reportPermission = [
            Permission.MANAGE_REPORTS,
            Permission.RUN_REPORTS,
            Permission.INVOICE_PRINTING
        ];
        this.period = Period;
        this.finalStoreIds = [];
        this.countryAndStoreData = [];
        this.countryIdForBsn = [];
        this.countryIdForIBAN = [];
        this.displayCountryName = null;
        // for dropdown
        /* for dropdown*/
        this.dropdownList = [];
        this.selectedItems = [];
        /* custom date ranges for order reports subcategory and order dashboard subcategory*/
        this.minDateRangeForDatePicker = null;
        this.selectAllStores = false;
        this.defaultLoad = true;
        this.memberStatus = [];
        this.previousStatus = '';
        this.newStatus = '';
        this.email = '';
        this.fboId = '';
    }
    ReportsComponent.prototype.ngOnInit = function () {
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.getPermissions();
        this.getCountries();
        this.getOperatingCountries();
        this.buildReportsForm();
        this.fromDate = this.momentConstructor(this.currentDate);
        this.toDate = this.momentConstructor(this.currentDate);
        this.getPosPaymentMethod();
        this.getSingleCountry();
        this.callingMultiSelect();
        //  for multi-select dropdown
        this.getReportCategories();
        this.getMemberStatus();
    };
    /**
     * To get agent permission
     */
    ReportsComponent.prototype.getPermissions = function () {
        this.hasManageReportPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.reportPermission[0] + ']'), AccessLevel.Customer_Service);
        this.hasRunReportPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.reportPermission[1] + ']'), AccessLevel.Customer_Service);
        this.hasInvoicePrintingPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.reportPermission[2] + ']'), AccessLevel.Customer_Service);
        this.activeTab = (this.hasManageReportPermission && this.hasInvoicePrintingPermission) ? this.reportTab.INVOICE_PRINTING : this.reportTab.REPORT;
    };
    /**
     * To build reports form
     */
    ReportsComponent.prototype.buildReportsForm = function () {
        this.reportsForm = this._formbuilder.group({
            operatingCountry: ['', Validators.required],
            store: ['', [Validators.required]],
            reportCategory: ['', [Validators.required]],
            subCategory: ['', [Validators.required]],
            fromDate: ['', [Validators.required, Utils.validateFromDate()]],
            toDate: ['', [Validators.required, Utils.validateToDate()]],
            posLocationId: [''],
            notesRequired: [false],
            period: ['', Validators.required],
            previousStatus: [''],
            newStatus: [''],
            email: [''],
            fboId: ['', Validators.minLength(12)]
        });
    };
    /**
     * To get all operating countries from configuration service
     */
    ReportsComponent.prototype.getOperatingCountries = function () {
        var _this = this;
        this._customerService.getAllBusinessEntities().subscribe(function (response) {
            if (response) {
                _this.businessEntities = response;
                _this.getAllowedOperatingCountries();
            }
        }, function (error) {
            _this.businessEntities = [];
        });
    };
    /**
     * To get allowed Countries based on permissions
     */
    ReportsComponent.prototype.getAllowedOperatingCountries = function () {
        var countryIds = [];
        if (this.userInfo && !this.userInfo.hasSystemRole) {
            if (this.userInfo.allowedOperatingCountries) {
                countryIds = this.userInfo.allowedOperatingCountries.split(',');
                countryIds = countryIds ? countryIds : [];
                if (countryIds && countryIds.length > 0) {
                    var ids_1 = countryIds;
                    this.operatingCountries = this.businessEntities.filter(function (item) {
                        return ids_1.indexOf(item.id + '') !== -1;
                    });
                }
            }
            else {
                this.operatingCountries = [];
            }
        }
        else {
            this.operatingCountries = this.businessEntities;
        }
        this.operatingCountries.sort(function (item1, item2) {
            var country1 = item1.name.toLowerCase(), country2 = item2.name.toLowerCase();
            if (country1 < country2) {
                return -1;
            }
            if (country1 > country2) {
                return 1;
            }
            return 0;
        });
        var countryInfo = this.operatingCountries.find(function (country) { return country.id === OperatingCountryEnums.USA; });
        if (countryInfo) {
            // this.operatingCountries.splice(this.countries.indexOf(countryInfo), 1);
            // this.operatingCountries.splice(0, 0, countryInfo);
            this.reportsForm.controls['operatingCountry'].setValue(countryInfo.id);
            this.getStoresByCountryCode(countryInfo.id, countryInfo.value);
            this.defaultLoad = false;
        }
        if (this.countries && this.countries.length > 0 && !countryInfo && !this.defaultLoad) {
            this.getStoresByCountryCode(this.operatingCountries[0].id, this.operatingCountries[0].value);
        }
    };
    /**
     * To get all countries from configuration service
     */
    ReportsComponent.prototype.getCountries = function () {
        var _this = this;
        this._customerService.getAllCountries(true).subscribe(function (response) {
            if (response) {
                _this.countries = response;
                if (_this.operatingCountries && _this.operatingCountries.length > 0) {
                    _this.getStoresByCountryCode(_this.operatingCountries[0].id, _this.operatingCountries[0].value);
                    _this.callingMultiSelect();
                }
            }
        }, function (error) {
            _this.countries = [];
        });
    };
    /**
     * To get operating country by country code
     */
    ReportsComponent.prototype.getStoresByCountryCode = function (operatingCountryId, isoCodeThree) {
        var _this = this;
        this.operatingCountryCode = isoCodeThree ? isoCodeThree : this.operatingCountries.find(function (operatingCountry) { return operatingCountry.id === +operatingCountryId; }).value;
        this._customerService.getOperatingCountriesByCountryCode(this.operatingCountryCode, true).subscribe(function (response) {
            if (response && response.countriesUnderOperatingCountry && response.countriesUnderOperatingCountry.length > 0) {
                _this.stores = [];
                response.countriesUnderOperatingCountry.forEach(function (countryOperatingCountry) {
                    var countries = _this.countries.filter(function (country) { return country.titanPlatformEnabled && country.enrollmentEnabled && country.shopEnabled
                        && country.isocodeThree === countryOperatingCountry.countryCode; });
                    if (countries && countries.length > 0) {
                        _this.stores = _this.stores.concat(countries);
                        _this.dropdownList = [];
                        _this.stores.forEach(function (obj) {
                            var newStore = { "id": 0, "itemName": "" };
                            newStore.id = obj.countryId;
                            newStore.itemName = obj.name;
                            _this.dropdownList.push(newStore);
                        });
                        _this.callingMultiSelect();
                    }
                });
            }
            else {
                _this.stores = [];
            }
        }, function (error) {
            _this.stores = [];
        });
    };
    ReportsComponent.prototype.getSingleCountry = function () {
        var _this = this;
        this.operatingCountries.forEach(function (country) {
            if (country.id == _this.reportsForm.controls.operatingCountry.value) {
                _this.displayCountryName = country.name;
            }
        });
    };
    /**
     * On operating country change event
     */
    ReportsComponent.prototype.onOperatingCountryChange = function (operatingCountryId) {
        this.getSingleCountry();
        this.reportsForm.controls['store'].setValue('');
        this.reportsForm.controls['reportCategory'].setValue('');
        this.reportsForm.controls['subCategory'].setValue('');
        this.subReports = [];
        this.finalStoreIds = [];
        this.countryIdForBsn = [];
        this.countryIdForIBAN = [];
        this.reportsForm.controls['period'].setValue('');
        this.getStoresByCountryCode(operatingCountryId);
    };
    /**
     * On store change event
     */
    ReportsComponent.prototype.onStoreChange = function (id) {
        this.posLocations = [];
        this.storeId = null;
        this.storeInfo = null;
        this.reportsForm.controls['subCategory'].setValue('');
        this.reportsForm.controls['posLocationId'].setValue('');
        //       this.reportsForm.controls['period'].setValue('');
        var countryCode = this.stores.filter(function (country) { return country.countryId === Number(id); })[0].isocodeThree;
        this.getStoreInfo(countryCode);
    };
    /**
     * On report category change event
     */
    ReportsComponent.prototype.onReportCategoryChange = function (reportCategory) {
        var _this = this;
        this.subReports = [];
        this.minDateRangeForDatePicker = null;
        this.reportsForm.controls['posLocationId'].setValue('');
        this.reportsForm.controls['subCategory'].setValue('');
        // this.reportsForm.controls['period'].setValue('');
        this.getReports(this.reportsForm.controls['operatingCountry'].value, this.reportsForm.controls['reportCategory'].value);
        if (reportCategory == ReportCategoryEnum.POS) {
            this.reportsForm.controls['posLocationId'].setValidators([Validators.required]);
            this.posLocations = [];
            this.finalStoreIds.forEach(function (StoreId) {
                _this.getPOSLocations(StoreId);
            });
        }
        else {
            this.reportsForm.controls['posLocationId'].setValidators(null);
        }
        this.reportsForm.controls['posLocationId'].setValue('');
        this.reportsForm.controls['posLocationId'].updateValueAndValidity();
        this.dataLoadedCount = 0;
    };
    /**
     * To get report categories
     */
    ReportsComponent.prototype.getReportCategories = function () {
        var _this = this;
        this._customerService.getLookupConfigValues('reportCategory').subscribe(function (response) {
            if (response && response.length > 0) {
                _this.reportCategories = response;
            }
            else {
                _this.reportCategories = [];
            }
        }, function (error) {
            _this.reportCategories = [];
        });
    };
    /**
     * To get POS location based on store
     */
    ReportsComponent.prototype.getPOSLocations = function (storeId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var posLocations;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPOSLocationsByStoreId(storeId)];
                    case 1:
                        posLocations = _a.sent();
                        posLocations.forEach(function (res) {
                            var posId = false;
                            _this.posLocations.forEach(function (pos) {
                                if (res.id === pos.id) {
                                    return posId = true;
                                }
                            });
                            if (!posId) {
                                _this.posLocations.push(res);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ReportsComponent.prototype.getPOSLocationsByStoreId = function (storeId) {
        return this._customerService.getPosLocationsByStore(storeId).toPromise();
    };
    /**
     * To get reports based on operating country
     */
    ReportsComponent.prototype.getReports = function (operatingCountryId, reportCategoryId) {
        var _this = this;
        this.isSubmitted = false;
        this._customerService.getReports(operatingCountryId, reportCategoryId).subscribe(function (response) {
            if (response && response.length > 0) {
                _this.subReports = response;
            }
            else {
                _this.subReports = [];
            }
        }, function (error) {
            _this.subReports = [];
        });
    };
    /**
     * To get store info by countryCode
     */
    ReportsComponent.prototype.getStoreInfo = function (countryCode) {
        var _this = this;
        this._orderService.getStoreInfo(countryCode).subscribe(function (response) {
            if (response) {
                _this.storeInfo = response;
                _this.storeId = response.id;
                if (!_this.reportCategories || _this.reportCategories.length === 0) {
                    _this.getReportCategories();
                }
            }
        }, function (error) {
            _this.storeInfo = null;
        });
    };
    /**
     * When subCategory value changes
     */
    ReportsComponent.prototype.subCategoryChanged = function () {
        this.reportsForm.controls['posLocationId'].setValue('');
        this.formValuesChanged();
        if (this.subCategoryConstants.OrdersReport === this.reportsForm.controls.subCategory.value) {
            var date = new Date();
            var currentMonthFirstDay = new Date(date.getFullYear(), date.getMonth(), 1).toLocaleDateString('en-CA');
            this.minDateRangeForDatePicker = currentMonthFirstDay;
            this.setOrderReportsDeafultDateAndValidataors();
        }
        else if (this.subCategoryConstants.OrdersDashboard === this.reportsForm.controls.subCategory.value || this.subCategoryConstants.BSNReport === this.reportsForm.controls.subCategory.value || this.subCategoryConstants.IBANReport === this.reportsForm.controls.subCategory.value) {
            this.setOrderDashboardReportsDeafultDateAndValidataors();
            var date = new Date();
            var previousMonthFirstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1).toLocaleDateString('en-CA');
            this.minDateRangeForDatePicker = previousMonthFirstDay;
        }
        else if (this.subCategoryConstants.AccountStatusChange === this.reportsForm.controls.subCategory.value) {
            this.setStatusDefaultValues();
            this.reportsForm.controls['period'].setValue('102');
            this.minDateRangeForDatePicker = null;
            this.setDefaultDateAndValidataors();
        }
        else if (this.subCategoryConstants.EnrollmentReport === this.reportsForm.controls.subCategory.value) {
            this.setDefaultEnrollmentReportValues();
            this.minDateRangeForDatePicker = null;
            this.setDefaultDateAndValidataors();
        }
        else {
            this.minDateRangeForDatePicker = null;
            this.setDefaultDateAndValidataors();
        }
    };
    /**
    * Set Default for previous and new status
    */
    ReportsComponent.prototype.setStatusDefaultValues = function () {
        this.previousStatus = '';
        this.newStatus = '';
        this.reportsForm.controls['previousStatus'].setValue('');
        this.reportsForm.controls['newStatus'].setValue('');
    };
    /**
    * Set Default Date & Validators for Ordres Dashboard Report
    */
    ReportsComponent.prototype.setOrderDashboardReportsDeafultDateAndValidataors = function () {
        var today = new Date();
        var yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        this.reportsForm.controls['fromDate'].setValue(this.momentConstructor(new Date(yesterday)));
        this.reportsForm.controls['toDate'].setValue(this.momentConstructor(new Date(today)));
        this.reportsForm.controls['fromDate'].setValidators([Validators.required, Utils.validateFromDate(2, 'M')]);
        this.reportsForm.controls['toDate'].setValidators([Validators.required, Utils.validateToDate(2, 'M')]);
        this.reportsForm.controls['fromDate'].updateValueAndValidity();
        this.reportsForm.controls['toDate'].updateValueAndValidity();
        /* customized for order dashborad subcategory*/
        this.dateRangeDuration = 2;
    };
    /**
     * Set Default Date & Validators for Ordres Report
     */
    ReportsComponent.prototype.setOrderReportsDeafultDateAndValidataors = function () {
        var today = new Date();
        var yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        this.reportsForm.controls['fromDate'].setValue(this.momentConstructor(new Date(yesterday)));
        this.reportsForm.controls['toDate'].setValue(this.momentConstructor(new Date(today)));
        this.reportsForm.controls['fromDate'].setValidators([Validators.required, Utils.validateFromDate(1, 'M')]);
        this.reportsForm.controls['toDate'].setValidators([Validators.required, Utils.validateToDate(1, 'M')]);
        this.reportsForm.controls['fromDate'].updateValueAndValidity();
        this.reportsForm.controls['toDate'].updateValueAndValidity();
        /**customized for order reports subcategory **/
        this.dateRangeDuration = 1;
    };
    /**
     * Set Default Date & Validators
     */
    ReportsComponent.prototype.setDefaultDateAndValidataors = function () {
        this.reportsForm.controls['fromDate'].setValue(this.momentConstructor(this.currentDate));
        this.reportsForm.controls['toDate'].setValue(this.momentConstructor(this.currentDate));
        this.reportsForm.controls['toDate'].setValidators([Validators.required, Utils.validateToDate(this.dateRangeDuration, 'M')]);
        this.reportsForm.controls['toDate'].updateValueAndValidity();
        this.reportsForm.controls['fromDate'].setValidators([Validators.required, Utils.validateFromDate(this.dateRangeDuration, 'M')]);
        this.reportsForm.controls['fromDate'].updateValueAndValidity();
        this.dateRangeDuration = environment.reportDownloadDurationMonths;
    };
    /**
    * Set Default for email and fboId
    */
    ReportsComponent.prototype.setDefaultEnrollmentReportValues = function () {
        this.email = '';
        this.fboId = '';
        this.reportsForm.controls['email'].setValue('');
        this.reportsForm.controls['fboId'].setValue('');
    };
    /**
     * When form values are changed
     */
    ReportsComponent.prototype.formValuesChanged = function () {
        this.isSubmitted = false;
        this.dataLoadedCount = 0;
    };
    /**
     * Update the date range validation for ToDate when change from Date
     */
    ReportsComponent.prototype.fromDateChange = function () {
        var _this = this;
        this.formValuesChanged();
        setTimeout(function () {
            if (!_this.reportsForm.controls['toDate'].valid
                && (_this.subCategoryConstants.OrdersReport !== _this.reportsForm.controls.subCategory.value) && (_this.subCategoryConstants.OrdersDashboard !== _this.reportsForm.controls.subCategory.value)
                && (_this.reportsForm.controls['toDate'].hasError('monthRangeValidation')
                    || _this.reportsForm.controls['toDate'].hasError('toDateValidation'))) {
                _this.reportsForm.controls['toDate'].setValidators([Validators.required, Utils.validateToDate(_this.dateRangeDuration, 'M')]);
                _this.reportsForm.controls['toDate'].updateValueAndValidity();
            }
            else if (!_this.reportsForm.controls['toDate'].valid
                && _this.reportsForm.controls['toDate'].hasError('dayRangeValidation')
                || _this.reportsForm.controls['toDate'].hasError('toDateValidation')) {
                _this.reportsForm.controls['toDate'].setValidators([Validators.required, Utils.validateToDate(2, 'M')]);
                _this.reportsForm.controls['toDate'].updateValueAndValidity();
            }
        }, 0);
    };
    /**
     * Update the date range validation for fromDate when change To Date
     */
    ReportsComponent.prototype.toDateChange = function () {
        var _this = this;
        this.formValuesChanged();
        setTimeout(function () {
            if (!_this.reportsForm.controls['fromDate'].valid
                && (_this.subCategoryConstants.OrdersReport !== _this.reportsForm.controls.subCategory.value)
                && (_this.reportsForm.controls['fromDate'].hasError('monthRangeValidation')
                    || _this.reportsForm.controls['fromDate'].hasError('fromDateValidation'))) {
                _this.reportsForm.controls['fromDate'].setValidators([Validators.required, Utils.validateFromDate(_this.dateRangeDuration, 'M')]);
                _this.reportsForm.controls['fromDate'].updateValueAndValidity();
            }
            else if (!_this.reportsForm.controls['fromDate'].valid
                && (_this.reportsForm.controls['fromDate'].hasError('dayRangeValidation')
                    || _this.reportsForm.controls['fromDate'].hasError('fromDateValidation'))) {
                _this.reportsForm.controls['fromDate'].setValidators([Validators.required, Utils.validateFromDate(1, 'M')]);
                _this.reportsForm.controls['fromDate'].updateValueAndValidity();
            }
        }, 0);
    };
    /**
     * To get store info by countryCode
     */
    ReportsComponent.prototype.onSubmitRunReport = function () {
        this.setContainer();
        var posLocationId = this.reportsForm.controls['posLocationId'].value;
        var areaInfo = this.posLocations.find(function (location) { return location.id === +posLocationId; });
        this.areaCode = areaInfo ? ((areaInfo.code ? areaInfo.code : '') + (areaInfo.name ? ' ' + areaInfo.name : '')) : '';
        if (this.reportsForm.controls['period'].value == this.period.CurrentMonth) {
            var date = new Date();
            var currentMonthFirstDay = new Date(date.getFullYear(), date.getMonth(), 1).toLocaleDateString('en-CA');
            // let currentMonthLastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleDateString('en-CA');
            this.formattedFromDate = currentMonthFirstDay;
            this.formattedToDate = date.toLocaleDateString('en-CA');
            this.setValidDateFormat(this.formattedFromDate, this.formattedToDate);
        }
        if (this.reportsForm.controls['period'].value == this.period.PreviousMonth) {
            var date = new Date();
            var previousMonthFirstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1).toLocaleDateString('en-CA');
            var previousMonthLastDay = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toLocaleDateString('en-CA');
            this.formattedFromDate = previousMonthFirstDay;
            this.formattedToDate = previousMonthLastDay;
            this.setValidDateFormat(this.formattedFromDate, this.formattedToDate);
        }
        if (this.reportsForm.controls['period'].value == this.period.CustomDates) {
            this.formattedFromDate = Utils.convertToSpecificDateFormat(moment(this.reportsForm.controls['fromDate'].value), DateConstants.DOBFormat);
            this.formattedToDate = Utils.convertToSpecificDateFormat(moment(this.reportsForm.controls['toDate'].value), DateConstants.DOBFormat);
        }
        if (this.reportsForm.controls['previousStatus'].value && this.reportsForm.controls['newStatus'].value) {
            this.previousStatus = MemberStatus[this.reportsForm.controls['previousStatus'].value];
            this.newStatus = MemberStatus[this.reportsForm.controls['newStatus'].value];
        }
        this.email = this.reportsForm.controls['email'].value;
        this.fboId = this.reportsForm.controls['fboId'].value;
        this.isLoading = true;
    };
    ReportsComponent.prototype.setValidDateFormat = function (fromDate, toDate) {
        if (fromDate && toDate) {
            this.formattedFromDate = moment(fromDate).format(DateConstants.DOBFormat);
            this.formattedToDate = moment(toDate).format(DateConstants.DOBFormat);
        }
    };
    /**
     * To Set Container when click run at second time
     */
    ReportsComponent.prototype.setContainer = function () {
        var _this = this;
        if (this.dataLoadedCount === 0) {
            this.isSubmitted = true;
        }
        else {
            this.isSubmitted = false;
            setTimeout(function (x) {
                _this.isSubmitted = true;
            }, 0);
        }
    };
    /**
     * To Get Pos Payment Methods
     */
    ReportsComponent.prototype.getPosPaymentMethod = function () {
        var _this = this;
        this._customerService.getPosPaymentMethod().subscribe(function (response) {
            if (response && response.length > 0) {
                _this.posPaymentMethods = response;
            }
            else {
                _this.posPaymentMethods = [];
            }
        }, function (error) {
            _this.posPaymentMethods = [];
        });
    };
    /**
     * To Handle the spinner load
     */
    ReportsComponent.prototype.dataLoaded = function () {
        this.dataLoadedCount++;
        this.isLoading = false;
    };
    ReportsComponent.prototype.addToFavorite = function () {
    };
    /**
     * To load screen based on tab selected
     */
    ReportsComponent.prototype.selectTab = function (tab) {
        this.activeTab = tab;
    };
    ReportsComponent.prototype.callingMultiSelect = function () {
        this.selectedItems = [];
        this.dropdownSettings = {
            singleSelection: false,
            text: "Select",
            selectAllText: "Select All",
            unSelectAllText: "UnSelect All",
            enableSearchFilter: false,
            classes: "myclass custom-class select.ng-valid",
            badgeShowLimit: 1
        };
    };
    ReportsComponent.prototype.onItemSelect = function (item) {
        var _this = this;
        this.posLocations = [];
        this.reportsForm.controls['posLocationId'].setValue('');
        this.reportsForm.controls['subCategory'].setValue('');
        var store = this.stores.find(function (x) { return x.countryId == (+item.id); });
        if (store && store.isocodeThree) {
            if (this.countryAndStoreData && this.countryAndStoreData.length > 0) {
                var data = this.countryAndStoreData.find(function (x) { return x.countryCode == store.isocodeThree; });
                this.storeId = null;
                if (data) {
                    this.storeId = data.storeId;
                    this.finalStoreIds.push(this.storeId);
                    if (!this.selectAllStores && this.reportsForm.controls['reportCategory'].value) {
                        this.onReportCategoryChange(this.reportsForm.controls['reportCategory'].value);
                    }
                }
            }
            if (!this.storeId) {
                this._orderService.getStoreInfo(store.isocodeThree).subscribe(function (response) {
                    if (response) {
                        _this.storeId = response.id;
                        _this.finalStoreIds.push(_this.storeId);
                        _this.countryAndStoreData.push({
                            countryCode: store.isocodeThree,
                            countryId: item.id,
                            storeId: _this.storeId
                        });
                        if (!_this.selectAllStores && _this.storeId && _this.reportsForm.controls['reportCategory'].value) {
                            _this.onReportCategoryChange(_this.reportsForm.controls['reportCategory'].value);
                        }
                    }
                });
            }
        }
        this.countryIdForBsn.push(item.id);
        this.countryIdForIBAN.push(item.id);
    };
    ReportsComponent.prototype.OnItemDeSelect = function (item) {
        this.reportsForm.controls['posLocationId'].setValue('');
        this.reportsForm.controls['subCategory'].setValue('');
        var data = this.countryAndStoreData.find(function (x) { return x.countryId == item.id; });
        if (data && data.storeId) {
            this.finalStoreIds = this.finalStoreIds.filter(function (storeId) {
                return data.storeId !== storeId;
            });
        }
        if (this.reportsForm.controls['reportCategory'].value) {
            this.onReportCategoryChange(this.reportsForm.controls['reportCategory'].value);
        }
        this.countryIdForBsn = this.countryIdForBsn.filter(function (countryId) {
            return item.id !== countryId;
        });
        this.countryIdForIBAN = this.countryIdForIBAN.filter(function (countryId) {
            return item.id !== countryId;
        });
    };
    ReportsComponent.prototype.onSelectAll = function (items) {
        var _this = this;
        this.selectAllStores = true;
        this.finalStoreIds = [];
        this.posLocations = [];
        this.reportsForm.controls['posLocationId'].setValue('');
        this.reportsForm.controls['subCategory'].setValue('');
        items.forEach(function (item) {
            _this.onItemSelect(item);
        });
        this.countryIdForBsn = [];
        this.countryIdForIBAN = [];
        items.forEach(function (item) {
            _this.countryIdForBsn.push(item.id);
        });
        items.forEach(function (item) {
            _this.countryIdForIBAN.push(item.id);
        });
        if (this.selectAllStores && this.reportsForm.controls['reportCategory'].value) {
            this.onReportCategoryChange(this.reportsForm.controls['reportCategory'].value);
        }
        this.selectAllStores = false;
        // this.finalStoreIds.push(items);
    };
    ReportsComponent.prototype.onDeSelectAll = function (items) {
        this.reportsForm.controls['posLocationId'].setValue('');
        this.reportsForm.controls['subCategory'].setValue('');
        this.finalStoreIds = [];
        if (this.reportsForm.controls['reportCategory'].value) {
            this.onReportCategoryChange(this.reportsForm.controls['reportCategory'].value);
        }
        this.countryIdForBsn = [];
        this.countryIdForIBAN = [];
    };
    /**
    * To get member status
    */
    ReportsComponent.prototype.getMemberStatus = function () {
        var _this = this;
        this._customerService.getMemberStatusesFromTitan().subscribe(function (response) {
            if (response) {
                _this.memberStatus = response;
            }
            else {
                _this.memberStatus = [];
            }
        }, function (error) {
            _this.memberStatus = [];
        });
    };
    return ReportsComponent;
}());
export { ReportsComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/reports/reports.component.ts.pre-build-optimizer.js